module.exports = __webpack_public_path__ + "media/images/FFE-700-63e74dc6b9c3a3c39a80567a0bea54c1.png";